var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import SurveyFillStore from "../../stores/SurveyFillStore";
import { States } from "reliance-private-survey-parser/dist/surveyParseTypes";
import { useStore } from "effector-react";
function MultiQuestionBox(props) {
    var _a;
    var q = props.q;
    var survey_fill = useStore(SurveyFillStore);
    var a = survey_fill.answerStorage[q.questionToken];
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "px-8" }, { children: [q.multiQuestionType === "CHECKBOXES" && (_jsx("div", { children: (_a = q.options) === null || _a === void 0 ? void 0 : _a.map(function (v, vIdx) {
                        var _a;
                        return (_jsx("div", { children: _jsxs("label", __assign({ className: "inline-flex items-center" }, { children: [_jsx("input", { type: "checkbox", className: "form-radio", name: "values.".concat(vIdx, "#id#").concat(q.questionToken), value: v, checked: Boolean(((_a = a.values) === null || _a === void 0 ? void 0 : _a[vIdx]) === v), onChange: function (e) {
                                            return props.handleChangeCallback(q.questionToken, e.target.name, e.target.checked ? v : "");
                                        } }, void 0), _jsx("span", __assign({ className: "ml-2" }, { children: v }), void 0)] }), void 0) }, vIdx));
                    }) }, void 0)), q.multiQuestionType === "STATES" && (_jsx("div", { children: Object.keys(States).map(function (v, vIdx) {
                        var _a;
                        return (_jsx("div", { children: _jsxs("label", __assign({ className: "inline-flex items-center" }, { children: [_jsx("input", { type: "checkbox", className: "form-radio", name: "values.".concat(vIdx, "#id#").concat(q.questionToken), value: v, checked: Boolean(((_a = a.values) === null || _a === void 0 ? void 0 : _a[vIdx]) === v), onChange: function (e) {
                                            return props.handleChangeCallback(q.questionToken, e.target.name, e.target.checked ? v : "");
                                        } }, void 0), _jsx("span", __assign({ className: "ml-2" }, { children: States[v] }), void 0)] }), void 0) }, vIdx));
                    }) }, void 0))] }), void 0) }, void 0));
}
export default MultiQuestionBox;
